import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getMostPopularPlan = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`statistic/most/popular/plan?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const getClientReports = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`statistic/client/reportes?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const getAssetStatistics = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`statistic/assets?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const getSupportLogs = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`statistic/support/logs?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const getNonSubscribedUsers = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`statistic/all/users?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const getOnlineOrdersInTenants = (queryParams = {}) => {
  const token = localStorage.getItem("authToken");
  return api.get(`statistic/online/orders/in/tenants?api_password=${API_PASSWORD}`, {
    params: queryParams,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};


